// @flow

import config from '../Config/Config';
import {getDocument, getWindow} from "./browsers";

let INIT = false;

function load(window, document) {

  // Load the Google Analytics library
  (function (i, s, o, g, r, a, m) {
    i['GoogleAnalyticsObject'] = r;
    i[r] = i[r] || function () {
      (i[r].q = i[r].q || []).push(arguments)
    };
    i[r].l = 1 * new Date();
    a = s.createElement(o);
    m = s.getElementsByTagName(o)[0];
    a.async = true;
    a.src = g;
    m && m.parentNode && m.parentNode.insertBefore(a, m)
  })(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga');
}

function allow(filters, trackingCall) {

  // If no filters have been defined then allow everything
  if (typeof filters === 'undefined') {
    return true;
  }

  return trackingCall &&
    trackingCall.length > 1 &&
    filters &&
    filters.length > 0 &&
    filters.indexOf(trackingCall[1]) !== -1;
}

export function track(argList: Array<any>): Promise<void> {
  return getWindow().then(window => {
    if (typeof window.ga === 'function') {
      let { googleAnalytics } = config;

      if (typeof googleAnalytics === 'undefined') {
        console.warn('[ga] Tried to call tracking without a GA configuration. Ignoring call.')
      } else {
        for (const tracker of googleAnalytics) {
          if (allow(tracker.filters, argList)) {
            let args = [].slice.call(argList);

            if (tracker.name) {
              args[0] = `${tracker.name}.${argList[0]}`;
            }

            window.ga.apply(window, args);
          }
        }
      }
    } else {
      console.warn('[ga] Tracking was called without GA tracking being initialized.')
    }
  });
}

export function event(...argList: Array<any>): Promise<void> {
  argList.unshift('send', 'event');
  return track(argList);
}

export function init() {
  let { googleAnalytics } = config;

  if (typeof googleAnalytics === 'undefined') {
    console.warn('[ga] No configuration information found for GA.')
  } else {
    return getWindow().then(window => {
      return getDocument().then(document => {
        if (!INIT) {
          INIT = true;
          load(window, document);

          console.log(googleAnalytics);

          for (const tracker of googleAnalytics) {
            let options = {
              name: tracker.name
            };

            if (typeof window.ga === 'function') {
              window.ga('create', tracker.key, 'auto', options);

              if (typeof tracker.plugins !== 'undefined') {
                for (const plugin of tracker.plugins) {
                  window.ga(`${tracker.name}.require`, plugin);
                }
              }
            } else {
              console.warn(`[ga] Failed to configure GA for ${tracker.name}. Ensure that GA has been successfully loaded first.`);
            }
          }
        } else {
          console.warn('[ga] Initialization was previously called. Ignoring init.');
        }
      });
    });
  }
}

